export const trackSeoEvent = (eventName, parameters = {}) => {
  if (typeof window === 'undefined' || !eventName) return;
  if (/^\/(?:my-trip|ops|admin)(?:\/|$)/.test(window.location.pathname)) return;

  const payload = {
    event: eventName,
    ...parameters,
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);

  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, parameters);
  }
};

export const initializeAnalytics = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (import.meta.env.VITE_LOCAL_DEMO === 'true' || /^\/(?:my-trip|ops|admin)(?:\/|$)/.test(window.location.pathname)) return;

  const measurementId = String(import.meta.env.VITE_GA_MEASUREMENT_ID || '').trim();
  if (!/^G-[A-Z0-9]+$/i.test(measurementId) || document.querySelector('[data-ntp-ga4]')) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, {
    anonymize_ip: true,
    send_page_view: false,
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  script.dataset.ntpGa4 = 'true';
  document.head.appendChild(script);
};

export default trackSeoEvent;
